import { Features as GetFeatures } from '@/common/get-features';
import { createContext } from 'react';

export type Features = GetFeatures;

export const FeaturesContext = createContext<Features | null>(null);
